import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/allocation/completionCheck/styles.scss';export default {
  "taskCompletionStatus": "_taskCompletionStatus_13b08_1",
  "late": "_late_13b08_11",
  "progressed": "_progressed_13b08_15",
  "completed": "_completed_13b08_19",
  "disabled": "_disabled_13b08_36",
  "constrained": "_constrained_13b08_47"
};